import Vue from 'vue';
import Vuex from 'vuex';
import { app } from './firebase.js';
import firebase from 'firebase/app';
import 'firebase/firestore';

Vue.use(Vuex);

const db = firebase.firestore(app);
const auth = firebase.auth(app);
const users = db.collection('users');
const books = db.collection('books');
const messages = db.collection('messages');

require('firebase/firestore');

// export default new Vuex.Store({
export const store = new Vuex.Store({
  state: {
    globalError: [],
    users: [],
    isLoggedIn: false,
    currentUser: [],
    books: [],
    messages: [],
  },
  getters: {
    //-------------- USER Getters --------------//
    getLoggedinState: state => {
      return state.isLoggedIn;
    },
    getGlobalError: state => {
      return state.getGlobalError;
    },
    //-------------- BOOK Getters --------------//
    //-------------- MESSAGE Getters --------------//
    myUnreadMessages: state => currentUserID => {
      return state.messages.filter(
        message => message.opened == false && message.to === currentUserID,
      );
    },
    myUnreadMessagesCount: state => currentUserID => {
      return state.messages.filter(
        message => message.opened == false && message.to === currentUserID,
      ).length;
    },
    unreadMessages: state => {
      return state.messages.filter(message => message.opened == false);
    },
    unreadMessagesCount: state => {
      return state.messages.filter(message => message.opened == false).length;
    },
  },
  mutations: {
    setGlobalError(state, error) {
      state.globalError.push(error);
    },
    //-------------- USER Mutations --------------//
    setUsers(state, users) {
      state.users = users;
    },
    setCurrentUser(state, payload) {
      state.currentUser = payload.data;
      state.currentUser.id = payload.userid;
    },
    removeUser(state, user) {
      state.users.splice(state.users.indexOf(user), 1);
    },
    setloggedInStatus(state, loggedInStatus) {
      state.isLoggedIn = loggedInStatus;
    },
    //-------------- BOOK Mutations --------------//
    setBooks(state, books) {
      state.books = books;
    },
    setCurrentBook(state, payload) {
      state.currentBook = payload;
    },
    removeBook(state, book) {
      state.books.splice(state.books.indexOf(book), 1);
    },
    //-------------- MESSAGE Mutations --------------//
    setMyMessages(state, messages) {
      state.messages = messages;
    },
    removeMessage(state, message) {
      state.messages.splice(state.messages.indexOf(message), 1);
    },
    setMessageRead(state, message) {
      state.messages.indexOf(message).opened = true;
    },
    setMessageUnread(state, message) {
      state.messages.indexOf(message).opened = false;
    },
  },
  actions: {
    setGlobalError({ commit }, error) {
      commit('setGlobalError', error);
    },
    //-------------- USER Actions --------------//
    addUser({ commit }, user) {
      users.add({ user });
      commit('addUser', user);
    },
    removeUser({ commit }, user) {
      users.doc(user).delete();
      users.doc(user).delete();
      commit('removeUser', user);
    },
    fetchUsers({ commit }) {
      users.onSnapshot(querySnapshot => {
        const myUsers = [];
        querySnapshot.forEach(doc => {
          myUsers.push({ id: doc.id, ...doc.data() });
        });
        commit('setUsers', myUsers);
      });
    },
    fetchCurrentUser({ commit }) {
      auth.onAuthStateChanged(user => {
        if (user) {
          users.doc(user.uid).onSnapshot(function(doc) {
            let payload = { data: doc.data(), userid: user.uid };
            commit('setCurrentUser', payload);
          });
        }
      });
    },
    setloggedInStatus({ commit }, status) {
      if (status) {
        commit('setloggedInStatus', status);
      } else {
        commit('setloggedInStatus', false);
      }
    },
    //-------------- BOOK Actions --------------//
    addBook({ commit }, book) {
      books.add({ book });
      commit('addBook', book);
    },
    removeBook({ commit }, book) {
      books.doc(book).delete();
      commit('removeBook', book);
    },
    fetchBook({ commit }, id) {
      users.doc(id).onSnapshot(function(doc) {
        commit('setCurrentBook', doc.data());
      });
    },
    borrowBook({ commit }, { book, myID }) {
      commit('borrowBook', { book, myID });
    },
    fetchBooks({ commit }) {
      books.onSnapshot(querySnapshot => {
        const allBooks = [];
        querySnapshot.forEach(doc => {
          allBooks.push({ id: doc.id, ...doc.data() });
        });
        commit('setBooks', allBooks);
      });
    },
    //-------------- MESSAGE Actions --------------//
    sendMessage({ commit }, message) {
      messages.add({ message });
      commit('addMessage', message);
    },
    removeMessage({ commit }, message) {
      messages.doc(message).delete();
      commit('removeMessage', message);
    },
    toogleMessageReadStatus({ dispatch }, { message, opened }) {
      if (opened) {
        dispatch('setMessageUnread', message);
      } else {
        dispatch('setMessageRead', message);
      }
    },
    setMessageUnread({ commit }, message) {
      messages.doc(message).set({
        opened: false,
      });
      commit('setMessageUnread', message);
    },
    setMessageRead({ commit }, message) {
      messages.doc(message).set({
        opened: false,
      });
      commit('setMessageRead', message);
    },
    fetchMessages({ commit }) {
      messages.onSnapshot(querySnapshot => {
        const myMessages = [];
        querySnapshot.forEach(doc => {
          myMessages.push({ id: doc.id, ...doc.data() });
        });
        commit('setMyMessages', myMessages);
      });
    },
  },
});
